"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("/var/www/easy_dev/extranet/node_modules/@babel/runtime/regenerator"));

var _eventBus = require("@/helpers/event-bus.js");

var _vuex = require("vuex");

var _LotDetail = _interopRequireDefault(require("./components/LotDetail"));

var _AffaireTotaux = _interopRequireDefault(require("./components/AffaireTotaux"));

var _Workflow = _interopRequireDefault(require("@/components/Workflow"));

var CONST = _interopRequireWildcard(require("@/helpers/constantes"));

var apiLotDetail = _interopRequireWildcard(require("@/api/lotdetail"));

var apiAffaire = _interopRequireWildcard(require("@/api/affaire"));

var _moment = _interopRequireDefault(require("moment"));

require("@/mixins/workflow");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = {
  name: 'BudgetAffaire',
  components: {
    LotDetail: _LotDetail.default,
    AffaireTotaux: _AffaireTotaux.default,
    Workflow: _Workflow.default
  },
  data: function data() {
    return {
      refresh: 0,
      CONST: CONST,
      userCanDoAction: false
    };
  },
  computed: _objectSpread({}, (0, _vuex.mapGetters)(['user']), {
    affaire: function affaire() {
      return this.$store.getters.affaire;
    }
  }),
  beforeMount: function () {
    var _beforeMount = _asyncToGenerator( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this = this;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getWorkflow('budget_affaire').then(function () {
                _this.userCanDoAction = _this.isUserCanDoAction(CONST.AFFAIRE.ETAPE.BUDGET_AFFAIRE.value, 'budget_affaire');
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeMount() {
      return _beforeMount.apply(this, arguments);
    }

    return beforeMount;
  }(),
  mounted: function mounted() {
    _eventBus.EventBus.$emit('REFRESH_CALCULS');

    this.refresh++;
  },
  methods: {
    periodeGestion: function periodeGestion() {
      _moment.default.locale('fr');

      var periode = (0, _moment.default)(this.$store.getters.affaire.YYYYMMmoins1, 'YYYYMM').format('MMMM YYYY');
      var isValidDate = (0, _moment.default)(this.$store.getters.affaire.YYYYMMmoins1, 'YYYYMM', true).isValid();
      return this.$store.getters.affaire.currentGestMensYYYYMM && isValidDate ? 'Gestion de ' + periode : '';
    },
    canEdit: function canEdit() {
      // edition possible uniquement si on est sur la période de gestion courante.
      return this.affaire.YYYYMM === this.affaire.currentGestMensYYYYMM;
    },
    // appel à partir de l'icone pour passer le lot en mode edition
    handleModeEdit: function handleModeEdit(lot) {
      // envoie le signal pour passer le lot en mode edition, traité dans le composant LotDetail
      _eventBus.EventBus.$emit('EDIT_LOT', lot.id);
    },
    // execution des actions en base de données
    action: function action(_action, lot) {
      var _this2 = this;

      // console.log(action, lot)
      this.$loader(true);
      this.$store.dispatch('affaire/' + _action, lot).then(function (results) {
        _this2.$store.dispatch('affaire/setLotDetail', lot).then(function () {
          _eventBus.EventBus.$emit('REFRESH_CALCULS');

          _this2.$loader(false);
        });
      }).catch(function (error) {
        _this2.$message(error);

        _this2.$loader(false);
      }).finally(function () {
        _this2.refresh++; // pour rafraichir l'écran
      });
    },
    // ================================
    handleBeforeToValidate: function handleBeforeToValidate() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        // on teste s'il y a des lignes cochées avec le nom du prestataire renseigné que pour les demandes de validation niveau 1 et niveau 2
        // recherche des lignes cochées: validation = 2
        var valid1 = _this3.affaire.lotsDetail.filter(function (x) {
          return x.validation === 2;
        }); // on regarde pour les lignes cochées si le nom du prestataire est renseigné


        var valid2 = valid1.filter(function (x) {
          return !x.prestataire || x.prestataire === '';
        }); // si conditions respectées alors on valide

        if (valid1.length > 0 && valid2.length === 0) {
          resolve();
        } else {
          // sinon affichage d'un message d'alerte
          _this3.$alert('Aucune nouvelle ligne cochée ou des noms de prestataire ne sont pas renseignés pour les nouvelles lignes cochées', 'Validation impossible', {
            confirmButtonText: 'Annuler',
            type: 'error'
          }).then(function () {
            reject(new Error());
          });
        }
      });
    },
    handleBeforeValidated: function handleBeforeValidated() {
      return this.handleBeforeToValidate();
    },
    handleAfterDeny: function handleAfterDeny() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        // on efface les lignes cochées pour réinitialisaer le cycle de validation
        apiLotDetail.resetAwaitingValidation(_this4.affaire.affaire.id).then(function () {
          resolve();
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    handleAfterValidated: function handleAfterValidated(workflow) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        // on valide les lignes cochées si des lignes ont leur champ validation = 2 (en attente de validation) pour les passer à 1 (ligne validée)
        apiLotDetail.validateByAffaireId(_this5.affaire.affaire.id); // si c'est la 1ere ouverture de la gestion mensuelle

        if (workflow.ecran === 'budget_affaire' && !_this5.affaire.currentGestMensYYYYMM) {
          apiAffaire.update(_this5.affaire.affaire.id, {
            statusBudgetAffaire: CONST.AFFAIRE.STATUS.CREATED.value,
            periode_gestmens: workflow.periode_gestmens
          }).then(function (result) {
            if (result.affectedRows > 0) {
              var periode = (0, _moment.default)(workflow.periode_gestmens, 'YYYYMM').subtract(1, 'months').format('MM/YYYY'); // mise à jour de l'historique pour signaler la date d'ouverture de la gestion mensuelle

              var histo = {
                id: _this5.affaire.affaire.id,
                etape: CONST.AFFAIRE.ETAPE.GESTION_MENSUELLE.value,
                status: CONST.AFFAIRE.STATUS.VALIDSYNTHESE.value,
                message: 'Ouverture de la période de gestion du ' + periode,
                data: workflow.periode_gestmens
              };

              _this5.$store.dispatch('affaire/setHistorique', histo);

              _this5.$message({
                message: 'Ouverture de la gestion mensuelle pour la période du ' + periode,
                type: 'success'
              });

              resolve();
            } else {
              reject(new Error());
            }
          }).catch(function (err) {
            reject(err);
          });
        } else {
          resolve();
        }
      });
    }
  }
};
exports.default = _default;